import { CSVLink } from 'react-csv';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Orders = () => {
  const [ordersData, setOrdersData] = useState([]);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await axios.get('https://astrovidhya.in/api/orders', {
        headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
      });
      setOrdersData(response.data);
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };

  const headers = [
    { label: 'Order ID', key: '_id' },
    { label: 'Customer Name', key: 'customer_name' },
    { label: 'Order Date', key: 'order_date' },
    { label: 'Total Amount', key: 'total_amount' },
    { label: 'Approval Status', key: 'approval_status' },
    { label: 'Assigned To', key: 'assigned_to.name' },
  ];

  return (
    <div className="m-4 p-4 bg-white rounded-lg shadow-md">
      <h1 className="text-xl font-bold mb-4">Orders</h1>
      <CSVLink
        data={ordersData}
        headers={headers}
        filename="orders.csv"
        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 mb-4 inline-block"
      >
        Download Orders as CSV
      </CSVLink>
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-200">
            <th className="border border-gray-300 px-4 py-2">Order ID</th>
            <th className="border border-gray-300 px-4 py-2">Customer Name</th>
            <th className="border border-gray-300 px-4 py-2">Order Date</th>
            <th className="border border-gray-300 px-4 py-2">Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {ordersData.map((order) => (
            <tr key={order._id}>
              <td className="border border-gray-300 px-4 py-2">{order._id}</td>
              <td className="border border-gray-300 px-4 py-2">{order.customer_name}</td>
              <td className="border border-gray-300 px-4 py-2">{order.order_date}</td>
              <td className="border border-gray-300 px-4 py-2">₹{order.total_amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Orders;
